<template>
  <div class="basic-layout" >
    <tags-view /> 
    <child />
  </div>
</template>

<script>

export default {
  name: 'BasicLayout',
  props: {
      type : {
          type : String,
          required: true
      },
      columns : {
          type : Array,
          default: () => []
      },
  },
  data(){
      return {

      }
  },
  created(){
      this.$store.commit('resource/setType', this.type)
      this.$store.commit('resource/setColumns', this.columns)
  },

}
</script>